import PaidHolidayAlertPage from './PaidHolidayAlertPage';

export default PaidHolidayAlertPage;
